import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './solicitacaoCompraForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import SelectDefault from '../common/form/selectDefault';

import { setModoTela, initForm, salvar, excluir, getLista } from './solicitacaoCompraActions';
import { getLista as getListaTipo } from '../compraTipo/compraTipoActions';
import { getLista as getListaCategoria } from '../compraCategoria/compraCategoriaActions';
import { getLista as getListaCliente } from '../cliente/clienteActions';
import { getLista as getListaProduto } from '../produto/produtoActions';
import { getLista as getListaPrioridade } from '../prioridade/prioridadeActions';

class SolicitacaoCompra extends Component {

	state = {
		linhaSelecionada: null,
		canceladas: false
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista(this.state.canceladas);
		this.props.getListaTipo();
		this.props.getListaCategoria();
		this.props.getListaCliente();
		this.props.getListaProduto();
		this.props.getListaPrioridade();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'cancelamento' ? (
						<Form cancelar onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}
					${item.numero}
					${item.nome_tipo}
					${item.nome_categoria}
					${item.nome_prioridade}
					${item.nome_cliente}
					${item.nome_produto}
					${FormatUtils.formatarValorTela(item.quantidade, 2)}
					${FormatUtils.formatarValorTela(item.prazo, 0)}
					${item.nome_usuario}
					${item.nome_status_pedido || 'Aguardando Pedido'}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		let agrupador = null;
		let posicao = 0;

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						{!this.state.canceladas &&
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ 
										formAberto: true
									});
								}} />
						</Grid>}
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Row>
						<Grid cols='12 8 8 10'>
							<input className='form-control'
								placeholder='Pesquisar'
								type='text'
								value={this.state.pesquisar}
								onChange={e => {
									this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
								}} />
						</Grid>
						<SelectDefault
							cols='12 4 4 2'
							options={[{ id: 1, valor: 'Abertas' }, { id: 2, valor: 'Canceladas' }]}
							value={this.state.canceladas ? 2 : 1}
							onChange={data => {
								this.setState({
									...this.state,
									canceladas: data.target.value == 2
								});
								this.props.getLista(data.target.value == 2);
							}} />
					</Row>
					{!this.state.canceladas &&
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Número</Th>
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Categoria</Th>
								<Th alignCenter>Prioridade</Th>
								<Th alignCenter>Cliente</Th>
								<Th alignCenter>Produto</Th>
								<Th alignCenter>Quantidade</Th>
								<Th alignCenter>Prazo</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Solicitante</Th>
								<Th alignCenter>Data/Hora</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {

								let prazo = parseInt(item.prazo || 0) - parseInt(item.dias_abertura || 0);
								
								if (agrupador != item.numero) {
									agrupador = item.numero;
									posicao++;

									let itens = lista.filter(itemAux => itemAux.numero == item.numero).length;

									let borderTop= '2px solid rgb(0, 48, 138, 0.8)';

									return (
										<Tr key={item.id} backgroundColor={'#ffffff'} >
											<Td rowspan={itens} alignCenter bold borderTop={borderTop}>{item.numero}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_tipo}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_categoria}</Td>
											<Td alignCenter small borderTop={borderTop}>
												<span class='badge badge-success' style={{ backgroundColor: item.cor_prioridade, fontSize: 12 }}>{item.nome_prioridade}</span>
											</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_cliente}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_produto}</Td>
											<Td alignCenter small borderTop={borderTop}>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
											<Td alignCenter small borderTop={borderTop} color={prazo <= 0 ? '#b50000' : '#000000'}>{
												prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
												: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
											}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_status_pedido || 'Aguardando Pedido'}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_usuario}</Td>
											<Td alignCenter small borderTop={borderTop}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}</Td>
											<Td rowspan={itens} alignRight minWidth={150} borderTop={borderTop}>
												<ButtonTable
													type={'warning'}
													icon={'fas fa-pencil-alt'}
													visible={true}
													event={() => {
														this.props.setModoTela('cadastro', {
															...item
														});
														this.props.initForm({
															...item
														});
													}} />
													
												<ButtonTable
													type={'danger'}
													icon={'fas fa-trash-alt'}
													visible={true}
													event={() => {
														this.props.setModoTela('exclusao', {
															...item
														});
														this.props.initForm({
															...item
														});
													}} />
											</Td>
										</Tr>
									);
								} else {
									return (
										<Tr key={item.id} backgroundColor={'#ffffff'} >
											<Td alignCenter small>{item.nome_tipo}</Td>
											<Td alignCenter small>{item.nome_categoria}</Td>
											<Td alignCenter small>
												<span class='badge badge-success' style={{ backgroundColor: item.cor_prioridade, fontSize: 12 }}>{item.nome_prioridade}</span>
											</Td>
											<Td alignCenter small>{item.nome_cliente}</Td>
											<Td alignCenter small>{item.nome_produto}</Td>
											<Td alignCenter small>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
											<Td alignCenter small color={prazo <= 0 ? '#b50000' : '#000000'}>{
												prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
												: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
											}</Td>
											<Td alignCenter small>{item.nome_status_pedido || 'Aguardando Pedido'}</Td>
											<Td alignCenter small>{item.nome_usuario}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}</Td>
										</Tr>
									);
								}
							})}
						</TBody>
					</Table>}


					{this.state.canceladas &&
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Número</Th>
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Categoria</Th>
								<Th alignCenter>Cliente</Th>
								<Th alignCenter>Produto</Th>
								<Th alignCenter>Quantidade</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Usuário</Th>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Motivo</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {

								let prazo = parseInt(item.prazo || 0) - parseInt(item.dias_abertura || 0);
								
								if (agrupador != item.numero) {
									agrupador = item.numero;
									posicao++;

									let itens = lista.filter(itemAux => itemAux.numero == item.numero).length;

									let borderTop= '2px solid rgb(0, 48, 138, 0.8)';

									return (
										<Tr key={item.id} backgroundColor={'#ffffff'} >
											<Td rowspan={itens} alignCenter bold borderTop={borderTop}>{item.numero}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_tipo}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_categoria}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_cliente}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_produto}</Td>
											<Td alignCenter small borderTop={borderTop}>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
											<Td alignCenter small borderTop={borderTop}><span class='badge badge-danger' style={{ fontSize: 12 }}>Cancelada</span></Td>
											<Td alignCenter small borderTop={borderTop}>{item.nome_usuario_cancelamento}</Td>
											<Td alignCenter small borderTop={borderTop}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_cancelamento)}</Td>
											<Td alignCenter small borderTop={borderTop}>{item.descricao_cancelamento}</Td>
										</Tr>
									);
								} else {
									return (
										<Tr key={item.id} backgroundColor={'#ffffff'} >
											<Td alignCenter small>{item.nome_tipo}</Td>
											<Td alignCenter small>{item.nome_categoria}</Td>
											<Td alignCenter small>{item.nome_cliente}</Td>
											<Td alignCenter small>{item.nome_produto}</Td>
											<Td alignCenter small>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
											<Td alignCenter small><span class='badge badge-danger' style={{ fontSize: 12 }}>Cancelada</span></Td>
											<Td alignCenter small>{item.nome_usuario_cancelamento}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_cancelamento)}</Td>
											<Td alignCenter small>{item.descricao_cancelamento}</Td>
										</Tr>
									);
								}
							})}
						</TBody>
					</Table>}
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.solicitacaoCompra.modoTela,
	aguardando: state.solicitacaoCompra.aguardando,
	lista: state.solicitacaoCompra.lista.filter(item => {
		if (state.auth.usuarioCarregado && (
			state.auth.usuarioCarregado.permissao_gerencia_compra
			|| state.auth.usuarioCarregado.permissao_visualiza_compra
		)) {
			return true;
		} else {
			return item.id_usuario_inclusao == state.auth.usuario.id;
		}
	})
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTipo, getListaCategoria, getListaCliente, getListaProduto, getListaPrioridade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SolicitacaoCompra);
